import React from "react";
import RecordingMicPopover from "./RecordingMicPopover";

const MicPopover = ({
  isActive,
  streamingTranscript,
  dictationLanguage,
  isCommandMode = false,
  aiEditStatus = null,
  onStop,
  isRadicalAuth = false,
  /** Agent Mode: small bottom-centre bar (the agent's report view is narrow). */
  compact = false,
}) => (
  <RecordingMicPopover
    isActive={isActive}
    streamingTranscript={streamingTranscript}
    dictationLanguage={dictationLanguage}
    isCommandMode={isCommandMode}
    aiEditStatus={aiEditStatus}
    onStop={onStop}
    isRadicalAuth={isRadicalAuth}
    variant="editor"
    compact={compact}
  />
);

export default MicPopover;
